import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { RoutesList } from "@/router/routesList";
import { useGetSportByIdQuery, useUpdateSportMutation } from "@/store/api";
import { useSetPageData } from "@/tools/hooks";
import { SportEditForm } from "./components/SportEditForm";
import { convertToUpdateDto } from "./mappers";
export var SportEditPage = function () {
    var sportId = useParams().sportId;
    var sportGetState = useGetSportByIdQuery({ id: sportId });
    var _a = useUpdateSportMutation(), sportUpdateAction = _a[0], sportUpdateState = _a[1];
    var saveFormHandler = function (data) {
        try {
            sportUpdateAction({
                id: sportId,
                updateSportDto: convertToUpdateDto(data),
            });
        }
        catch (err) {
            console.error(err);
        }
    };
    var cancelFormHandler = function () {
        navigate(RoutesList.Manage.getSportsList());
    };
    var navigate = useNavigate();
    useEffect(function () {
        if (sportUpdateState.isSuccess) {
            navigate(RoutesList.Manage.getSportsList());
        }
    }, [sportUpdateState.isSuccess]);
    useSetPageData({ title: "Вид спорта" });
    return (sportGetState.isSuccess && (_jsx(SportEditForm, { data: sportGetState.data, onSave: saveFormHandler, onCancel: cancelFormHandler })));
};
